module.exports = __webpack_public_path__ + "static/media/zoot.fa8c88dd.jpg";